import { OutlookControllerV3ApiFactory } from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { useFunctionalAreas } from "$root/App/context";
import { useCrumbs } from "$root/components/Crumbs/useCrumbs";
import { OutlookWidgetData } from "$root/components/OutlookWidgetData";
import { PageHeader } from "$root/components/PageHeader";
import { downloadContentDisposition } from "$root/utils";
import WidgetsGrid from "$root/widgets-architecture/layout/WidgetsGrid";
import { PageDownloadMenu } from "../components/PageDownloadMenu";
import mdotmMarketAnalysis from "$root/assets/MDOTM - Risk Moves to Rates - Equity Held, Credit Traded for the Front End.pdf";

const Dashboard = (): React.JSX.Element => {
	const crumbs = useCrumbs();
	// The dashboard has nothing to select, so being here is the whole of the context — and that is
	// what tells Sphere AI to answer from the cross-asset read rather than a single market's default.
	useFunctionalAreas(() => ({ areas: "marketDashboard", data: { open: true } }), []);
	return (
		<>
			<PageHeader
				crumbs={crumbs.marketInsights("Market dashboard")}
				subTitle={<OutlookWidgetData />}
				titleAction={
					<PageDownloadMenu
						area="dashboard"
						actions={[
							{
								icon: "xls",
								label: "Market outlook",
								onClickAsync: async () =>
									downloadContentDisposition(
										await getApiGen(OutlookControllerV3ApiFactory).createExcelReport({
											responseType: "blob",
										}),
									),
								"data-qualifier": "Dashboard/DropdownMenu/DropdownItem(XLSReport)",
							},
							{
								icon: "pdf",
								label: "MDOTM Market insights",
								onClick: () => {
									const anchor = document.createElement("a");
									anchor.href = mdotmMarketAnalysis;
									anchor.download = "MDOTM - Risk Moves to Rates - Equity Held, Credit Traded for the Front End.pdf";
									anchor.click();
								},
								"data-qualifier": "Outlook/DropdownMenu/DropdownItem(MdotmReportAnalysis)",
							},
						]}
					/>
				}
			/>
			<WidgetsGrid gridName="DASHBOARD" />
		</>
	);
};

export default Dashboard;
